module.exports = __webpack_public_path__ + "img/oms-logo-login.26be8fb7.png";